'use strict';
// https://github.com/tc39/proposal-decorator-metadata
require('../modules/esnext.function.metadata');
require('../modules/esnext.symbol.metadata');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/decorator-metadata-v2.js
// module id = 1002
// module chunks = 31